import AddSectionStyle from '@/styles/components/careers/add-section/_index.module.scss';
import { AboutSection, GallerySection, BenfitSection, MeetTeamSection, ReOrderSection, HeaderLinks, FooterLinks, SocialLinks, CustomButtons, HeroTitle} from '@/imports-files/pages/career/customize-career-page';
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from "react-accessible-accordion"; 


export function AddSection({formik, sidebar_section, customizeCareerAction, setFonts, formRef}){
return(
 <div className={`${AddSectionStyle.SidePanel__AddSection}`}>
    <Accordion allowZeroExpanded>
      <AccordionItem>
          <AccordionItemHeading>
              <AccordionItemButton>
                <p>Add a Section</p>
              </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
             <AboutSection formik={formik} sidebar_section={sidebar_section} customizeCareerAction={customizeCareerAction} />
             <GallerySection formik={formik} sidebar_section={sidebar_section} customizeCareerAction={customizeCareerAction} />
             <BenfitSection formik={formik} sidebar_section={sidebar_section} customizeCareerAction={customizeCareerAction} />
             <MeetTeamSection formik={formik} sidebar_section={sidebar_section} customizeCareerAction={customizeCareerAction} />
          </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem className = {`accordion__item re-ordertab`}>
          <AccordionItemHeading>
              <AccordionItemButton>
                  <p>Re-order page</p>
              </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
              <ReOrderSection formik={formik} customizeCareerAction={customizeCareerAction} formRef={formRef}/>
          </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem>
          <AccordionItemHeading>
              <AccordionItemButton>
                  <p>Styles</p>
              </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
              <HeroTitle formik={formik} sidebar_section={sidebar_section} customizeCareerAction={customizeCareerAction} setFonts={setFonts} />
              <CustomButtons formik={formik} sidebar_section={sidebar_section} customizeCareerAction={customizeCareerAction} setFonts={setFonts}  />
          </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem>
          <AccordionItemHeading>
              <AccordionItemButton>
                  <p>Navigation Links</p>
              </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
              <HeaderLinks formik={formik} sidebar_section={sidebar_section} customizeCareerAction={customizeCareerAction} />
              <FooterLinks formik={formik} sidebar_section={sidebar_section} customizeCareerAction={customizeCareerAction} />
              <SocialLinks formik={formik} sidebar_section={sidebar_section} customizeCareerAction={customizeCareerAction} />
          </AccordionItemPanel>
      </AccordionItem>
    </Accordion>
  </div>
  )
 }       